import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Clock3, Sparkles } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

const PricingLink = ({ children }) => (
  <Link
    to="/pricing"
    className="font-bold underline decoration-2 underline-offset-4 hover:opacity-80"
  >
    {children}
  </Link>
);

export const ChatFreeQuotaBanner = ({ entitlement }) => {
  const { t, formatNumber } = useI18n();
  const remaining = entitlement?.freeTierTokensRemaining;
  const exhausted = remaining != null && Number(remaining) <= 0;
  const hours = formatNumber(entitlement?.quotaWindowHours || 3);
  const resetTime = useMemo(() => {
    if (!entitlement?.freeQuotaResetsAt) {
      return '';
    }
    const date = new Date(entitlement.freeQuotaResetsAt);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return t('chatFreeQuotaClock', {
      hour: date.getHours(),
      minute: String(date.getMinutes()).padStart(2, '0')
    });
  }, [entitlement?.freeQuotaResetsAt, t]);

  if (!entitlement || entitlement.hasPackage) {
    return null;
  }

  return (
    <div className="mb-0 mt-3 overflow-hidden rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-start dark:border-amber-500/30 dark:bg-amber-500/10">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-200">
          {exhausted ? <Clock3 size={18} strokeWidth={2.2} /> : <Sparkles size={18} strokeWidth={2.2} />}
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold leading-6 text-amber-950 dark:text-amber-100">
            {entitlement.upgradeNotice || t('noPackageBanner')}{' '}
            <PricingLink>{t('pricingPurchaseTitle')}</PricingLink>
          </p>
          {exhausted && resetTime ? (
            <p className="mt-1 text-sm leading-6 text-amber-900/80 dark:text-amber-100/80">
              {t('chatFreeQuotaExhausted', { time: resetTime, hours })}{' '}
              <PricingLink>{t('upgradePlan')}</PricingLink>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
